export function AdminSettings() {
  return (
    <div className="mx-auto max-w-3xl space-y-2">
      <h1 className="text-2xl font-bold tracking-tight">Settings</h1>
      <p className="text-muted-foreground">Platform settings are coming soon.</p>
    </div>
  )
}
